import { CompassCardUI } from '@scale/compass-ui/types';
import { faGaugeMax } from '@fortawesome/pro-solid-svg-icons';
import {
  MANUALLY_PRIORITISE_TASKS,
  ManuallyPrioritiseTasksCardShared,
  ManuallyPrioritiseTasksSchemaType,
  type ManuallyPrioritiseTasksContext,
} from '@scale/genai-compass-shared/cards/manually_prioritise_tasks';
import ManuallyPrioritiseTasksCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/ManuallyPrioritiseTasksCard/ManuallyPrioritiseTasksCard';

const defaultContext: ManuallyPrioritiseTasksContext = {
  cardType: MANUALLY_PRIORITISE_TASKS,
  taskIdColumn: '',
  priorityColumn: '',
};

export const ManuallyPrioritiseTasksCardInfo: CompassCardUI<ManuallyPrioritiseTasksSchemaType> = {
  ...ManuallyPrioritiseTasksCardShared,
  title: 'Manually Prioritise Tasks',
  icon: 'gauge-max',
  toolTip: 'Manually prioritise tasks',
  defaultContext,
  component: ManuallyPrioritiseTasksCardComponent,
  showOutput: false,
  button: {
    icon: faGaugeMax,
    title: 'Prioritise Tasks',
  },
};
